export interface Config{
    REACT_APP_PANDER_API_URL: string;
    REACT_APP_PANDER_API_KEY: string;
}

const requiredVariables: (keyof Config)[] = [
    'REACT_APP_PANDER_API_URL',
    'REACT_APP_PANDER_API_KEY',
];

const partialConfig: Partial<Config> = {

};

for (const key of requiredVariables) {

    if (!process.env[key]) {
        throw new Error(`Missing required environment variable: ${key}`);
    }

    const value = process.env[key];

    if (value) {
        partialConfig[key] = value as any;
    }
}

export const config = partialConfig as Config;